<template>
  <div
    v-if="item && Object.keys(item).length > 0"
    class="barcode-label"
    :class="[
      'text-' + textAlign,
      fontOptions.includes('bold') ? 'barcode-bold' : '',
      fontOptions.includes('italic') ? 'barcode-italic' : '',
    ]"
    :style="{
      fontFamily: 'var(--app-font)',
      padding: `${marginTop}px ${marginLeft}px ${marginBottom}px ${marginRight}px`,
      backgroundColor: background,
    }"
  >
    <!-- Custom Prefix -->
    <div
      v-if="customPrefix"
      class="font barcode-text"
      :style="{
        fontSize: fontSize + 'px',
        marginBottom: textMargin + 'px',
      }"
    >
      {{ customPrefix }}
    </div>

    <!-- Product Name -->
    <div
      v-if="showName"
      class="font barcode-text"
      :style="{
        fontSize: fontSize + 'px',
        marginBottom: textMargin + 'px',
      }"
    >
      {{ item.name }}
      <span v-if="showSize && item.size"> - {{ item.size.name }}</span>
    </div>

    <!-- Price -->
    <div
      v-if="showPrice"
      class="font barcode-text"
      :style="{
        fontSize: fontSize + 'px',
        marginBottom: textMargin + 'px',
      }"
    >
      {{ moneyFormatPrint(item.price_sale) }}
    </div>

    <!-- Product Code (if enabled separately) -->
    <div
      v-if="showCode"
      class="font barcode-text"
      :style="{
        fontSize: fontSize + 'px',
        marginBottom: textMargin + 'px',
      }"
    >
      {{ item.code }}
    </div>

    <!-- Barcode -->
    <barcode
      class="barcode-svg"
      :value="item.code"
      :width="width"
      :height="height"
      :fontSize="fontSize"
      :fontOptions="fontOptions"
      :textAlign="textAlign"
      :textMargin="textMargin"
      :displayValue="displayValue"
      :lineColor="lineColor"
      :background="background"
      :marginTop="marginTop"
      :marginBottom="marginBottom"
      :marginLeft="marginLeft"
      :marginRight="marginRight"
      :format="format"
    />

    <!-- Custom Suffix -->
    <div
      v-if="customSuffix"
      class="font barcode-text"
      :style="{
        fontSize: fontSize + 'px',
        marginTop: textMargin + 'px',
      }"
    >
      {{ customSuffix }}
    </div>
  </div>
</template>

<script>
import { myMixin } from "@/mixin/main";
import VueBarcode from "vue-barcode";

export default {
  components: {
    barcode: VueBarcode,
  },
  mixins: [myMixin],
  props: {
    item: Object,
    selected: {
      type: Array,
      default: () => ["name", "size", "money"],
    },
    // Typography
    fontSize: {
      type: Number,
      default: 15,
    },
    fontOptions: {
      type: String,
      default: "normal",
    },
    textAlign: {
      type: String,
      default: "center",
    },
    textMargin: {
      type: Number,
      default: 5,
    },
    displayValue: {
      type: Boolean,
      default: true,
    },
    // Barcode dimensions
    width: {
      type: Number,
      default: 2,
    },
    height: {
      type: Number,
      default: 36,
    },
    lineColor: {
      type: String,
      default: "#000000",
    },
    background: {
      type: String,
      default: "#ffffff",
    },
    // Margins
    marginTop: {
      type: Number,
      default: 10,
    },
    marginBottom: {
      type: Number,
      default: 10,
    },
    marginLeft: {
      type: Number,
      default: 10,
    },
    marginRight: {
      type: Number,
      default: 10,
    },
    // Barcode format
    format: {
      type: String,
      default: "CODE128",
    },
    // Content display flags
    showName: {
      type: Boolean,
      default: true,
    },
    showPrice: {
      type: Boolean,
      default: true,
    },
    showSize: {
      type: Boolean,
      default: false,
    },
    showCode: {
      type: Boolean,
      default: false,
    },
    // Custom text
    customPrefix: {
      type: String,
      default: "",
    },
    customSuffix: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
/* Barcode label container */
.barcode-label {
  display: inline-block;
  text-align: center;
  box-sizing: border-box;
}

.barcode-label.text-left {
  text-align: left;
}

.barcode-label.text-center {
  text-align: center;
}

.barcode-label.text-right {
  text-align: right;
}

/* Font styling using app font */
.barcode-text {
  font-family: var(--app-font);
  line-height: 1.2;
  word-wrap: break-word;
  color: #000000;
}

.barcode-bold {
  font-weight: bold;
}

.barcode-italic {
  font-style: italic;
}

/* Barcode SVG styling */
.barcode-svg {
  display: block;
  max-width: 100%;
}

.barcode-svg svg {
  display: block;
  max-width: 100%;
  height: auto;
}
</style>
